//// Application Configuration
import libphonenumber from 'google-libphonenumber'
import { format, differenceInDays, isBefore } from 'date-fns'

//// Application Packages

//// Application Slices

//// Application Components

//// Carbon Components

//// Carbon Icons

//// Static Constants

// Translate Field (Utility)
export const translateField = (fields, field) => {
    if (fields && field) {
        const entry = fields[field]
        if (entry) {
            return entry
        }
    }
}

// Translate Field (Multi-Form)
export const translateMultiFormField = (fields, max_form_iterations, field) => {
    if (fields && field) {
        // Check In Result Variable
        const entry = {}

        // Check For Initial Itterative Form
        entry.converted = fields[field]

        // Check For Itterative Form (0-9)
        if (!entry?.['converted']) {
            // Extract Last Character Of Array
            const lastVarChar = field?.slice(-1).toString()

            // Check For Characters In Max Form Iterations
            const number = max_form_iterations?.indexOf(lastVarChar)

            // Check For Index Of VarChar In Max Form Interations
            if (number > -1) {
                // Clean Key From Appended Number
                const fldArr = Array.from(field)
                const last = fldArr.length - 1
                const newArr = fldArr.splice(0, last)
                const cleanKey = newArr.join('')

                // Check For Clean Key
                if (cleanKey) {
                    // Check Fields For Field
                    const convertedExt = fields?.[cleanKey]

                    // Check For Converted Extended
                    if (convertedExt) {
                        entry.converted = convertedExt
                    }
                }
            }
        }

        // Check For Itterative Form (10 - 50)
        if (!entry?.['converted']) {
            // Extract Last Two Characters Of Array
            const lastTwoVarChar = field?.slice(-2).toString()

            // Check For Characters In Max Form Iterations
            const number = max_form_iterations?.indexOf(lastTwoVarChar)

            // Check For Index Of VarChar In Max Form Interations
            if (number > -1) {
                // Clean Key From Appended Number
                const fldArr = Array.from(field)
                const lastTwo = fldArr.length - 2
                const newArr = fldArr.splice(0, lastTwo)
                const cleanKey = newArr.join('')

                // Check For Clean Key
                if (cleanKey) {
                    // Check Fields For Field
                    const convertedExt = fields?.[cleanKey]

                    // Check For Converted Extended
                    if (convertedExt) {
                        entry.converted = convertedExt
                    }
                }
            }
        }

        // Check For Converted Field Entry
        if (entry?.['converted']) {
            return entry.converted
        } else {
            return field
        }
    }
}

// Matching (Check)
export const matchingEvaluationField = async (one, two) => {
    try {
        if (one && two) {
            // Create Arrays From Fields One & Two
            const oneArr = Array?.from(one)
            const twoArr = Array?.from(two)
            const oneMatchArr = []
            const twoMatchArr = []
            if (oneArr?.length > 0 && twoArr?.length > 0) {
                // Check If All Characters In First Array Are Equal To Second Array
                oneArr.forEach((el, i) => {
                    if (el === twoArr[i]) {
                        oneMatchArr.push(true)
                    } else {
                        oneMatchArr.push(false)
                    }
                })

                // Check If All Characters In Second Array Are Equal To First Array
                twoArr.forEach((el, i) => {
                    if (el === oneArr[i]) {
                        twoMatchArr.push(true)
                    } else {
                        twoMatchArr.push(false)
                    }
                })
            }

            // Check If Array Includes False Boolean
            const oneMatchResult = oneMatchArr?.indexOf(false)
            const twoMatchResult = twoMatchArr?.indexOf(false)

            // Check Matching Results
            if (oneMatchResult === -1 && twoMatchResult === -1) {
                return true
            } else {
                return false
            }
        } else if (!one && !two) {
            return true
        } else {
            return false
        }
    } catch (error) {
        console.warn('Matching Field Evaluation Error:', error)
        return null
    }
}

// Password (Check)
export const passwordEvaluationField = async (password, userid) => {
    try {
        const fld = {}
        if (password && userid) {
            // Test Uppercase Inclusion
            const charPwd = password
                .replace(/0/g, '')
                .replace(/1/g, '')
                .replace(/2/g, '')
                .replace(/3/g, '')
                .replace(/4/g, '')
                .replace(/5/g, '')
                .replace(/6/g, '')
                .replace(/7/g, '')
                .replace(/8/g, '')
                .replace(/9/g, '')
                .replace(/!/g, '')
                .replace(/@/g, '')
                .replace(/#/g, '')
                .replace(/\$/g, '')
                .replace(/%/g, '')
                .replace(/\^/g, '')
                .replace(/&/g, '')
                .replace(/\*/g, '')
                .replace(/\(/g, '')
                .replace(/\)/g, '')
                .replace(/-/g, '')
                .replace(/_/g, '')
                .replace(/=/g, '')
                .replace(/\+/g, '')
                .replace(/;/g, '')
                .replace(/:/g, '')
                .replace(/\[/g, '')
                .replace(/\{/g, '')
                .replace(/\]/g, '')
                .replace(/\}/g, '')
                .replace(/\\/g, '')
                .replace(/\|/g, '')
                .replace(/\?/g, '')
                .replace(/\//g, '')
                .replace(/\.,/g, '')
                .replace(/>/g, '')
                .replace(/,/g, '')
                .replace(/</g, '')
                .replace(/`/g, '')
                .replace(/~/g, '')
            const charPwdArr = Array.from(charPwd)
            const charPwdUpcs = charPwd.toUpperCase()
            const charPwdUpcsArr = Array.from(charPwdUpcs)
            const charPwdUpcsTstArr = []
            if (charPwdArr?.length > 0 && charPwdUpcsArr?.length > 0) {
                charPwdArr.forEach((el, i) => {
                    if (el === charPwdUpcsArr[i]) {
                        charPwdUpcsTstArr.push(i)
                    }
                })
            }
            if (charPwdUpcsTstArr?.length > 0) {
                fld.upcs = true
            } else {
                fld.upcs = false
            }

            // Test Lowercase Inclusion
            const charPwdLwcs = charPwd.toLowerCase()
            const charPwdLwcsTstArr = []
            if (charPwdArr?.length > 0 && charPwdLwcs?.length > 0) {
                charPwdArr.forEach((el, i) => {
                    if (el === charPwdLwcs[i]) {
                        charPwdLwcsTstArr.push(i)
                    }
                })
            }
            if (charPwdLwcsTstArr?.length > 0) {
                fld.lwcs = true
            } else {
                fld.lwcs = false
            }

            // Test Number Inclusion
            const numPwd = password
                .replace(/a/g, '')
                .replace(/b/g, '')
                .replace(/c/g, '')
                .replace(/d/g, '')
                .replace(/e/g, '')
                .replace(/f/g, '')
                .replace(/g/g, '')
                .replace(/h/g, '')
                .replace(/i/g, '')
                .replace(/j/g, '')
                .replace(/k/g, '')
                .replace(/l/g, '')
                .replace(/m/g, '')
                .replace(/n/g, '')
                .replace(/o/g, '')
                .replace(/p/g, '')
                .replace(/q/g, '')
                .replace(/r/g, '')
                .replace(/s/g, '')
                .replace(/t/g, '')
                .replace(/u/g, '')
                .replace(/v/g, '')
                .replace(/w/g, '')
                .replace(/x/g, '')
                .replace(/y/g, '')
                .replace(/z/g, '')
                .replace(/A/g, '')
                .replace(/B/g, '')
                .replace(/C/g, '')
                .replace(/D/g, '')
                .replace(/E/g, '')
                .replace(/F/g, '')
                .replace(/G/g, '')
                .replace(/H/g, '')
                .replace(/I/g, '')
                .replace(/J/g, '')
                .replace(/K/g, '')
                .replace(/L/g, '')
                .replace(/M/g, '')
                .replace(/N/g, '')
                .replace(/O/g, '')
                .replace(/P/g, '')
                .replace(/Q/g, '')
                .replace(/R/g, '')
                .replace(/S/g, '')
                .replace(/T/g, '')
                .replace(/U/g, '')
                .replace(/V/g, '')
                .replace(/W/g, '')
                .replace(/X/g, '')
                .replace(/Y/g, '')
                .replace(/Z/g, '')
                .replace(/!/g, '')
                .replace(/@/g, '')
                .replace(/#/g, '')
                .replace(/\$/g, '')
                .replace(/%/g, '')
                .replace(/\^/g, '')
                .replace(/&/g, '')
                .replace(/\*/g, '')
                .replace(/\(/g, '')
                .replace(/\)/g, '')
                .replace(/-/g, '')
                .replace(/_/g, '')
                .replace(/=/g, '')
                .replace(/\+/g, '')
                .replace(/;/g, '')
                .replace(/:/g, '')
                .replace(/\[/g, '')
                .replace(/\{/g, '')
                .replace(/\]/g, '')
                .replace(/\}/g, '')
                .replace(/\\/g, '')
                .replace(/\|/g, '')
                .replace(/\?/g, '')
                .replace(/\//g, '')
                .replace(/\.,/g, '')
                .replace(/>/g, '')
                .replace(/,/g, '')
                .replace(/</g, '')
                .replace(/`/g, '')
                .replace(/~/g, '')
            const numPwdArr = Array.from(numPwd)
            if (numPwdArr?.length > 0) {
                fld.num = true
            } else {
                fld.num = false
            }

            // Test Special Character Inclusion
            const spcPwd = password
                .replace(/a/g, '')
                .replace(/b/g, '')
                .replace(/c/g, '')
                .replace(/d/g, '')
                .replace(/e/g, '')
                .replace(/f/g, '')
                .replace(/g/g, '')
                .replace(/h/g, '')
                .replace(/i/g, '')
                .replace(/j/g, '')
                .replace(/k/g, '')
                .replace(/l/g, '')
                .replace(/m/g, '')
                .replace(/n/g, '')
                .replace(/o/g, '')
                .replace(/p/g, '')
                .replace(/q/g, '')
                .replace(/r/g, '')
                .replace(/s/g, '')
                .replace(/t/g, '')
                .replace(/u/g, '')
                .replace(/v/g, '')
                .replace(/w/g, '')
                .replace(/x/g, '')
                .replace(/y/g, '')
                .replace(/z/g, '')
                .replace(/A/g, '')
                .replace(/B/g, '')
                .replace(/C/g, '')
                .replace(/D/g, '')
                .replace(/E/g, '')
                .replace(/F/g, '')
                .replace(/G/g, '')
                .replace(/H/g, '')
                .replace(/I/g, '')
                .replace(/J/g, '')
                .replace(/K/g, '')
                .replace(/L/g, '')
                .replace(/M/g, '')
                .replace(/N/g, '')
                .replace(/O/g, '')
                .replace(/P/g, '')
                .replace(/Q/g, '')
                .replace(/R/g, '')
                .replace(/S/g, '')
                .replace(/T/g, '')
                .replace(/U/g, '')
                .replace(/V/g, '')
                .replace(/W/g, '')
                .replace(/X/g, '')
                .replace(/Y/g, '')
                .replace(/Z/g, '')
                .replace(/0/g, '')
                .replace(/1/g, '')
                .replace(/2/g, '')
                .replace(/3/g, '')
                .replace(/4/g, '')
                .replace(/5/g, '')
                .replace(/6/g, '')
                .replace(/7/g, '')
                .replace(/8/g, '')
                .replace(/9/g, '')
            const spcPwdArr = Array.from(spcPwd)
            if (spcPwdArr?.length > 0) {
                fld.spc = true
            } else {
                fld.spc = false
            }

            // Test Must Not Be Same As Username
            const pwd = Array.from(password)
            const usr = Array.from(userid)
            const pwdLen = pwd.length
            const usrLen = usr.length
            const pwdUsrTst = []
            if (pwd?.length > 0 && usr?.length > 0) {
                pwd.forEach((el, i) => {
                    if (el === usr[i]) {
                        pwdUsrTst.push(el)
                    }
                })
            }
            if (
                (pwdLen === usrLen && pwdUsrTst?.length === pwdLen) ||
                pwdUsrTst?.length === usrLen
            ) {
                fld.no_mtch = false
            } else {
                fld.no_mtch = true
            }

            // Validate All Test
            const { upcs, lwcs, num, spc, no_mtch } = fld
            if (upcs && lwcs && num && spc && no_mtch) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    } catch (error) {
        console.warn('Password Evaluation Error:', error)
        return null
    }
}

// Integer Length (Check)
export const integerLengthEvaluationField = async (
    formsData,
    digital_name,
    field,
    max
) => {
    try {
        if (formsData?.[digital_name]?.values?.[field]) {
            const str = formsData?.[digital_name]?.values?.[field]?.toString()
            const len = str?.length
            if (len && max) {
                if (len < max) {
                    return true
                } else if (len === max) {
                    return true
                } else if (len === 0) {
                    return true
                } else {
                    return false
                }
            } else if (len === 0) {
                return true
            }
        } else {
            return true
        }
    } catch (error) {
        console.warn('Matching Field Evaluation Error:', error)
        return null
    }
}

// Phone Number Evaluation (Check)
export const phoneNumberEvaluationField = async (
    formsData,
    digital_name,
    field
) => {
    try {
        if (formsData?.[digital_name]?.values?.[field]) {
            const str = formsData?.[digital_name]?.values?.[field]?.toString()
            if (str) {
                const phoneUtil = libphonenumber?.PhoneNumberUtil?.getInstance()
                if (phoneUtil) {
                    const phoneNumber = phoneUtil?.parseAndKeepRawInput(
                        str,
                        'US'
                    )
                    if (phoneNumber) {
                        const phoneNumberValid =
                            phoneUtil?.isValidNumber(phoneNumber)
                        if (phoneNumberValid) {
                            return true
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            } else {
                return false
            }
        } else {
            return true
        }
    } catch (error) {
        console.warn('Phone Number Evaluation Error:', error)
        return null
    }
}

// Date Equal To Today (Check)
export const dateEqualToTodayField = async (formsData, digital_name, field) => {
    try {
        if (formsData?.[digital_name]?.values?.[field]) {
            const dte = formsData?.[digital_name]?.values?.[field]?.toString()
            if (dte) {
                const now = format(new Date(), 'MM/dd/yyyy').toString()
                if (now) {
                    const diff = differenceInDays(new Date(now), new Date(dte))
                    if (diff === 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            } else {
                return false
            }
        } else {
            return true
        }
    } catch (error) {
        console.warn('Date Equal To Today Error:', error)
        return null
    }
}

// Date Before Today (Check)
export const dateBeforeTodayField = async (formsData, digital_name, field) => {
    try {
        if (formsData?.[digital_name]?.values?.[field]) {
            const dte = formsData?.[digital_name]?.values?.[field]?.toString()
            if (dte) {
                const now = format(new Date(), 'MM/dd/yyyy').toString()
                if (now) {
                    const check = isBefore(new Date(dte), new Date(now))
                    if (check) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            } else {
                return false
            }
        } else {
            return true
        }
    } catch (error) {
        console.warn('Date Before Today Error:', error)
        return null
    }
}

// SSN Restrict To Integer Value
export const ssnRestrictToIntValueField = (value) => {
    if (value) {
        const len = value?.length
        if (len === 1) {
            const int = parseInt(value)
            if (!isNaN(int)) {
                return true
            } else {
                return false
            }
        } else if (len > 1) {
            const valueArr = Array?.from(value)
            const lastValueCharVar = valueArr?.splice(-1)
            const int = parseInt(lastValueCharVar)
            if (!isNaN(int)) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    } else {
        return false
    }
}

// SSN Present But Not Beyond Minimum
export const ssnPresentButNotBeyondMinimumField = async (
    formsData,
    digital_name,
    field
) => {
    try {
        if (formsData?.[digital_name]?.values?.[field]) {
            const len = formsData?.[digital_name]?.values?.[field]?.length
            if (len > 0) {
                if (len < 9) {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        } else {
            return true
        }
    } catch (error) {
        console.warn('Date Equal To Today Error:', error)
        return null
    }
}
